import { z } from "zod";
var pad = function (time) {
    return time.toString().padStart(2, "0");
};
var durationRegex = /^(?:(\d{1,2}):)?(\d{1,2}):(\d{1,2})(?:\.(\d{1,3}))?$/;
var stringDurationToMilliseconds = z.string().regex(durationRegex).transform(function (duration) {
    var match = duration.match(durationRegex);
    if (match) {
        var hours = parseInt(match[1], 10) || 0;
        var minutes = parseInt(match[2], 10);
        var seconds = parseInt(match[3], 10);
        var milliseconds = parseInt(match[4], 10) || 0;
        return (hours * 3600 + minutes * 60 + seconds) * 1000 + milliseconds;
    }
    else {
        throw new Error("Invalid duration: ".concat(duration));
    }
});
var transformMillisecondsToStringDuration = function (milliseconds) {
    var totalSeconds = Math.floor(milliseconds / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var millisecondsStr = milliseconds.toString().slice(-3);
    var formattedTime = '';
    if (hours > 0) {
        formattedTime += "".concat(hours.toString().padStart(2, '0'), ":");
    }
    formattedTime += "".concat(minutes.toString().padStart(2, '0'), ":").concat(seconds.toString().padStart(2, '0'), ".").concat(millisecondsStr);
    return formattedTime;
};
var millisecondsToStringDuration = z.number().transform(transformMillisecondsToStringDuration);
/**
 * @deprecated please use `transformMillisecondsToStringDuration`
 */
var msToTime = function (time) {
    var ms = time % 1000;
    time = (time - ms) / 1000;
    var secs = time % 60;
    time = (time - secs) / 60;
    var mins = time % 60;
    var hrs = (time - mins) / 60;
    return "".concat(hrs > 0 ? "".concat(pad(hrs), ":") : "").concat(pad(mins), ":").concat(pad(secs));
};
/**
 * @deprecated please use `stringDurationToMilliseconds`
 */
var timeToMs = function (time) {
    var regex = new RegExp(/^(([01]\d|2[0-3]):)?(?:[0-5]\d):(?:[0-5]\d)$/);
    if (!regex.test(time)) {
        return null;
    }
    var parts = time
        .split(":")
        .map(function (part) { return parseInt(part); })
        .reverse();
    var ms = 0;
    parts.forEach(function (part, index) {
        switch (index) {
            case 0:
                ms = ms + part * 1000;
                break;
            case 1:
                ms = ms + part * 60 * 1000;
                break;
            case 2:
                ms = ms + part * 60 * 60 * 1000;
                break;
            default:
                break;
        }
    });
    return ms;
};
export { durationRegex, stringDurationToMilliseconds, millisecondsToStringDuration, transformMillisecondsToStringDuration, timeToMs, msToTime };
//# sourceMappingURL=time.js.map